module.exports = [
  'اسلام آباد',
  'پشاور',
  'لاہور',
  'کراچی',
  'ملتان',
  'نوشہرہ',
  'مردان',
  'چارسدہ',
  'گوجرنوالہ',
  'گجرات',
  'منگورہ',
  'ملاکنڈ',
  'درگیٗ',
  'حیدرآباد',
  'ایبٹ آباد',
  'ناران',
  'فیصل آباد',
  'راولپنڈی',
  'کوئٹہ',
  'بہاولپور',
  'سیالکوٹ',
  'لاڑکانہ',
  'رحیم یار خان',
  'قصُور',
  'اوکاڑا‎',
  'نواب شاہ',
  'چنیوٹ',
  'حافظ آباد',
  'کوھاٹ',
  'جہلم',
  'وارسک',
  'خانپور',
  'حب',
  'دسکہ',
  'خزدار',
  'مری',
  'گوجرہ',
  'دادو',
  'چشتیاں',
  'ٹیکسلا',
  'کبل',
  'گوٹکی',
  'نارو وال',
  'گوادر',
];
